// import React from 'react';
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import dateTimeHelper from "../Helpers/datetimeHelper";

export default class CaspianXXQueryProcessingHistoryItem {
  constructor(item) {
    if (item === undefined) {
      this.Id = '';
      this.RealQuery = '';
      this.Type = '';
      this.Option1 = '';
      this.StartDate = dateTimeHelper.toYYYYsMMsDD(new Date());
      this.EndDate = dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addMonthsToDate(new Date(), 6));
      this.TimeSpan = 'true';
      this.Error = '';
      this.Next = '';
      return;
    }
    this.initialize(item);
  }

  async initialize(item) {
    this.Id = item.id;
    this.RealQuery = item.realQuery;
    this.Type = item.type;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.TimeSpan = item.timeSpan;
    this.Error = item.error;
    this.Next = item.next;
  }

  static NameOfTheIdField() {
    return 'Id';
  }
  static nameOfTheItemDetailList() {
    return 'CaspianXx Query Processing History';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [
        { name: 'Id', label: 'Id' },
        { name: 'Type', label: 'Type' },
        { name: 'TimeSpan', label: 'Time Span' },
        { name: 'StartDate', label: 'Start Date' },
        { name: 'EndDate', label: 'End Date' },
        { name: 'RealQuery', label: 'Real Query', width: TabListTableCellWidthEnum.TwoLines, className: 'text-left' },
        { name: 'Error', label: 'Error', width: TabListTableCellWidthEnum.TwoLines, className: 'text-left' },
        { name: 'Next', label: 'Next', width: TabListTableCellWidthEnum.TwoLines, className: 'text-left' },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: 'Id', orderById: 'Id', data: 'Id', type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: 'Type', orderById: 'Type', data: 'Type' },
      { label: 'TimeSpan', orderById: 'TimeSpan', data: 'TimeSpan', minWidth: 50 },
      {
        label: 'Start Date',
        orderById: 'StartDate',
        data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.StartDate),
        minWidth: 50,
      },
      {
        label: 'End Date',
        orderById: 'EndDate',
        data: (item) => dateTimeHelper.toYYYYsMMsDDsHHsMMsSS(item.EndDate),
        minWidth: 50,
      },
    ];
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
